import {getLocalText, useDblIntl} from "@/pages/datalab/utils/utils";
import React from "react";
import { Button, Modal } from "tea-component";
import './index.scss';

const DeleteModal = (props: any) => {
  const { setShowDeleteModal, deletedFunc, deleteRecord, canDeleted } = props;
  const { dblFormatMessage, commonFormatMessage, isEn } = useDblIntl("myAnalysis");

  return <>
    {
      canDeleted ? <Modal
        visible={true}
        onClose={() => {
          setShowDeleteModal(false);
        }}
      >
        <Modal.Body className="modal-context">
          <Modal.Message
            message={dblFormatMessage("sure_to_delete_chart_title")}
            description={dblFormatMessage("sure_to_delete_chart_message", { name: <span className="dbl_text-strong">{getLocalText(isEn, deleteRecord?.name_cn, deleteRecord?.name)}</span> })}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            onClick={() => {
              setShowDeleteModal(false);
              deletedFunc();
            }}
          >
            {commonFormatMessage("confirm")}
          </Button>
          <Button
            type="weak"
            onClick={() => {
              setShowDeleteModal(false);
            }}
          >
            {commonFormatMessage("cancel")}
          </Button>
        </Modal.Footer>
      </Modal> : <Modal
        visible={true}
        onClose={() => {
          setShowDeleteModal(false);
        }}
      >
        <Modal.Body className="modal-context">
          <Modal.Message
            icon="error"
            message={dblFormatMessage("can_not_delete_chart_title")}
            description={dblFormatMessage("can_not_delete_chart_message")}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            onClick={() => {
              setShowDeleteModal(false);
            }
            }
          >
            {dblFormatMessage("chart_i_know")}
          </Button>
        </Modal.Footer>
      </Modal>

    }


  </>;

};

export default DeleteModal;